import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";

export const GetAllClaimDashboard = createAsyncThunk(
    "claimDashboard/GetAllClaimDashboard",
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiInstance.post("insurance/claimdashboard", params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
